/* LinkAndSyncDetailRenderer.js */

"use strict";

const CheckBoxControl = require("@gluenetworks/steve_ui_core").Control.Boolean.InputCheckbox;

const {
    Control: {
        Action: {Button},
    },
} = require("@gluenetworks/steve_ui_core");

class LinkAndSyncDetailRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("base-link-and-sync-veil-gl");
        this._rootElem.component = this._model;
        this._syncServiceNowControl = new CheckBoxControl({
            label: "Sync with ServiceNow",
            labelShown: true,
            darkTheme: true,
            disabled: true,
        });
        this._syncNetBoxControl = new CheckBoxControl({
            label: "Sync with NetBox",
            labelShown: true,
            darkTheme: true,
            disabled: true,
        });
        this._syncXdControl = new CheckBoxControl({
            label: "Sync with xDome",
            labelShown: true,
            darkTheme: true,
            disabled: true,
        });
        this._syncAllControl = new CheckBoxControl({
            label: "Sync new devices and sites from NetBox",
            labelShown: true,
            darkTheme: true,
            disabled: true,
        });
        this._confirmButton = new Button({
            label: "Start Sync",
            darkTheme: true,
            class: "additive",
        });
        this._cancelButton = new Button({
            label: "Cancel",
            darkTheme: true,
        });

        this._titleComponent = document.createElement("h2");
        this._titleComponent.innerText = this._model._title;
        this._messageBox = this._createMessageBox();
        this._buttonContainer = this._createButtonContainer();
        this._registerListeners();
    }

    _createMessageBox() {
        const message = document.createElement("p");
        message.innerHTML = `A job will launch with the following options:`;

        return message;
    }

    _createButtonContainer() {
        const buttonContainer = document.createElement("button-container");
        buttonContainer.appendChild(this._cancelButton.renderer.rootElement);
        buttonContainer.appendChild(this._confirmButton.renderer.rootElement);
        return buttonContainer;
    }

    _registerListeners() {
        this._syncServiceNowControl.on("UserValue", this._toggleServiceNowSyncAction.bind(this));
        this._syncNetBoxControl.on("UserValue", this._toggleNetboxSyncAction.bind(this));
        this._syncAllControl.on("UserValue", this._toggleAllSyncAction.bind(this));
        this._syncXdControl.on("UserValue", this._toggleXdSyncAction.bind(this));
        this._confirmButton.on("UserClick", this._onConfirmButtonClick.bind(this));
        this._cancelButton.on("UserClick", this._onCancelButtonClick.bind(this));
    }

    _unregisterListeners() {
        this._syncServiceNowControl.removeAllListeners("UserValue");
        this._syncNetBoxControl.removeAllListeners("UserValue");
        this._syncAllControl.removeAllListeners("UserValue");
        this._syncXdControl.removeAllListeners("UserValue");
        this._confirmButton.removeAllListeners("UserClick");
        this._cancelButton.removeAllListeners("UserClick");
    }

    _onConfirmButtonClick() {
        this._callConfirmAction();
    }

    _onCancelButtonClick() {
        this._model.cancelAction();
    }

    _callConfirmAction() {
        this._model.linkAndSyncAction();
    }

    _toggleServiceNowSyncAction(val) {
        this._syncActionSet("serviceNow", val);
    }

    _toggleXdSyncAction(val) {
        this._syncActionSet("xDome", val);
    }

    _toggleNetboxSyncAction(val) {
        this._syncActionSet("netBox", val);
        this._model._showNetBoxAllDeviceOption
            ? this._syncAllControl.setDisabled(!val)
            : this._syncAllControl.setDisabled(true);
    }

    _toggleAllSyncAction(val) {
        this._model._orderedSync.allDevices = val;
    }

    _syncActionSet(type, val) {
        this._model._orderedSync[type] = val;
        this._confirmButton.setDisabled(
            !this._syncServiceNowControl.getValue() &&
                !this._syncNetBoxControl.getValue() &&
                !this._syncXdControl.getValue()
        );
    }

    shutdown() {
        this._unregisterListeners();

        const promArr = [
            this._confirmButton.shutdown(),
            this._cancelButton.shutdown(),
            this._syncServiceNowControl.shutdown(),
            this._syncNetBoxControl.shutdown(),
            this._syncAllControl.shutdown(),
        ];

        return Promise.all(promArr).then(() => {
            this._confirmButton =
                this._buttonContainer =
                this._titleComponent =
                this._messageBox =
                this._model =
                this._rootElem =
                this._syncServiceNowControl =
                this._syncNetBoxControl =
                this._syncAllControl =
                this._cancelButton =
                    undefined;
        });
    }

    render() {
        return Promise.resolve().then(() => {
            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.appendChild(this._titleComponent);
                this._rootElem.appendChild(this._messageBox);

                //workaround because checkbox form el cannot set a class
                this._syncAllControl.renderer.rootElement.className = "netBoxRequired";

                //show/hide options
                if (this._model._showServiceNowOption) {
                    this._rootElem.appendChild(this._syncServiceNowControl.renderer.rootElement);
                    this._syncServiceNowControl.setDisabled(false).setValue(true);
                }
                if (this._model._showNetBoxOption) {
                    this._rootElem.appendChild(this._syncNetBoxControl.renderer.rootElement);
                    this._rootElem.appendChild(this._syncAllControl.renderer.rootElement);
                    this._syncNetBoxControl.setDisabled(false).setValue(true);
                }
                if (this._model._showNetBoxAllDeviceOption) {
                    this._syncAllControl.setDisabled(false);
                }
                if (this._model._showXdOption) {
                    this._rootElem.appendChild(this._syncXdControl.renderer.rootElement);
                    this._syncXdControl.setDisabled(false).setValue(true);
                }

                this._rootElem.appendChild(this._buttonContainer);
            }
            return Promise.resolve();
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }
}

module.exports = LinkAndSyncDetailRenderer;
